"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveIdentificationTypeIdentity = resolveIdentificationTypeIdentity;
exports.getIdentificationTypeIdentity = getIdentificationTypeIdentity;
exports.hasOverlappingIdentificationTypes = hasOverlappingIdentificationTypes;
var normalize = function (value) {
    var normalizedValue = value === null || value === void 0 ? void 0 : value.trim().replace(/\s+/g, ' ').toLowerCase();
    return normalizedValue || undefined;
};
var legacyIdentificationTypeValues = new Set([
    'Social Security Number',
    'Drivers License',
    'Goverment Issued Picture ID',
    'Military ID',
    'Passport Number',
    'Student Identification Number',
    'VISA',
].map(normalize));
var legacyIdentificationTypeBySystemCode = new Map([
    ['DR LIC', 'Drivers License'],
    ['GOV ID', 'Goverment Issued Picture ID'],
    ['MIL ID', 'Military ID'],
    ['VISA', 'VISA'],
    ['STAT ID', 'Goverment Issued Picture ID'],
    ['PASS ID', 'Passport Number'],
    ['STUD ID', 'Student Identification Number'],
].map(function (_a) {
    var systemCode = _a[0], legacyType = _a[1];
    return [
        normalize(systemCode),
        normalize(legacyType),
    ];
}));
function normalizeSystemCodeAlias(value) {
    var normalizedValue = normalize(value);
    return ((normalizedValue &&
        legacyIdentificationTypeBySystemCode.get(normalizedValue)) ||
        normalizedValue);
}
function matchesLegacyIdentificationType(identificationType, companyType) {
    var legacyCustomType = normalize(identificationType.customType);
    if (!legacyCustomType ||
        !legacyIdentificationTypeValues.has(legacyCustomType)) {
        return false;
    }
    var legacyValues = [
        normalize(identificationType.name),
        normalize(identificationType.label),
        normalize(identificationType.displayName),
        legacyCustomType,
    ].filter(function (value) { return value !== undefined; });
    var companyValues = [
        normalizeSystemCodeAlias(companyType.systemCode),
        normalize(companyType.name),
        normalize(companyType.label),
        normalize(companyType.displayName),
    ].filter(function (value) { return value !== undefined; });
    return legacyValues.some(function (value) { return companyValues.includes(value); });
}
function resolveIdentificationTypeIdentity(identificationType, companyTypes) {
    if (companyTypes === void 0) { companyTypes = []; }
    if (identificationType.identificationTypeId != null) {
        return "identification:".concat(identificationType.identificationTypeId);
    }
    var matchingCompanyType = companyTypes.find(function (companyType) {
        return companyType.identificationTypeId != null &&
            matchesLegacyIdentificationType(identificationType, companyType);
    });
    if ((matchingCompanyType === null || matchingCompanyType === void 0 ? void 0 : matchingCompanyType.identificationTypeId) != null) {
        return "identification:".concat(matchingCompanyType.identificationTypeId);
    }
    return identificationType.customType
        ? "custom:".concat(identificationType.customType)
        : undefined;
}
function getIdentificationTypeIdentity(identificationType) {
    return resolveIdentificationTypeIdentity(identificationType);
}
function hasOverlappingIdentificationTypes(primaryIdTypes, additionalIdTypes, companyTypes) {
    if (primaryIdTypes === void 0) { primaryIdTypes = []; }
    if (additionalIdTypes === void 0) { additionalIdTypes = []; }
    if (companyTypes === void 0) { companyTypes = []; }
    var identificationTypes = __spreadArray(__spreadArray(__spreadArray([], primaryIdTypes, true), additionalIdTypes, true), companyTypes.map(function (companyType) { return ({
        identificationTypeId: companyType.id,
        systemCode: companyType.system_code,
        name: companyType.name,
    }); }), true);
    var primaryIdentities = new Set(primaryIdTypes
        .map(function (identificationType) {
        return resolveIdentificationTypeIdentity(identificationType, identificationTypes);
    })
        .filter(function (identity) { return identity !== undefined; }));
    return additionalIdTypes.some(function (identificationType) {
        var identity = resolveIdentificationTypeIdentity(identificationType, identificationTypes);
        return identity !== undefined && primaryIdentities.has(identity);
    });
}
